export default __webpack_public_path__ + "static/media/company_logo.5cd12935.png";